export enum SnackType {
    Standard,
    Error,
    Success,
    ProgressBar
}
